import { type ModelName } from '@pigello/pigello-matrix';
import { handleCustomApartmentNestedCase } from './apartment';
import { handleCustomApartmentContractRevenueIncreaseRowNestedCase } from './apartment-contract-revenue-increase-row';
import { handleCustomApartmentRevenueIncreaseRowNestedCase } from './apartment-revenue-increase-row';
import { brfCompanyNestedCase } from './brfcompany';
import { handleCustomGeneralErrandNestedCase } from './general-errand';
import { handleCustomIndustrialPremisesRevenueIncreaseRowNestedCase } from './industrial-premises-revenue-increase-row';
import { handleCustomIndustrialPremisesNestedCase } from './industrialpremises';
import { handleCustomInspectionErrandNestedCase } from './inspection-errand';
import { handleCustomInvoiceNestedCase } from './invoice';
import { handleCustomNotificationNestedCase } from './notification-distribution';
import { handleCustomOutdoorSectionRevenueIncreaseRowNestedCase } from './outdoor-section-revenue-increase-row';
import { handleCustomOutdoorSectionNestedCase } from './outdoorsection';
import { handleCustomParkingSpotRevenueIncreaseRowNestedCase } from './parking-spot-revenue-increase-row';
import { handleCustomParkingSpotNestedCase } from './parkingspot';
import { handleProtectedIdentityNestedCase } from './protected-identity';
import { brfApartmentRevenueProposalNestedCase } from './retroactive-brf-apartment-revenue-proposal';
import { handleCustomSubTenantNestedCase } from './sub-tenant';
import { handleCustomVacancyInvoiceNestedCase } from './vacancy-invoice';

// Registry for custom case handlers
export type TCustomList<T> = { data: T[] };

// Handler functions type
type CustomCaseHandler<T = unknown> = (
  listResponse: TCustomList<T>
) => Promise<TCustomList<T>>;

export const customCaseHandlers: Partial<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Record<ModelName, CustomCaseHandler<any>>
> = {
  apartment: handleCustomApartmentNestedCase,
  industrialpremises: handleCustomIndustrialPremisesNestedCase,
  outdoorsection: handleCustomOutdoorSectionNestedCase,
  parkingspot: handleCustomParkingSpotNestedCase,
  brfcompany: brfCompanyNestedCase,
  invoice: handleCustomInvoiceNestedCase,
  notificationdistribution: handleCustomNotificationNestedCase,
  apartmentrevenueincreaserow:
    handleCustomApartmentRevenueIncreaseRowNestedCase,
  industrialpremisesrevenueincreaserow:
    handleCustomIndustrialPremisesRevenueIncreaseRowNestedCase,
  parkingspotrevenueincreaserow:
    handleCustomParkingSpotRevenueIncreaseRowNestedCase,
  outdoorsectionrevenueincreaserow:
    handleCustomOutdoorSectionRevenueIncreaseRowNestedCase,
  apartmentcontractrevenueincreaserow:
    handleCustomApartmentContractRevenueIncreaseRowNestedCase,
  industrialpremisescontractrevenueincreaserow:
    handleCustomIndustrialPremisesRevenueIncreaseRowNestedCase,
  parkingspotcontractrevenueincreaserow:
    handleCustomParkingSpotRevenueIncreaseRowNestedCase,
  outdoorsectioncontractrevenueincreaserow:
    handleCustomOutdoorSectionRevenueIncreaseRowNestedCase,
  vacancyinvoice: handleCustomVacancyInvoiceNestedCase,
  protectedidentity: handleProtectedIdentityNestedCase,
  generalerrand: handleCustomGeneralErrandNestedCase,
  inspectionerrand: handleCustomInspectionErrandNestedCase,
  subtenant: handleCustomSubTenantNestedCase,
  retroactivebrfapartmentrevenueproposal: brfApartmentRevenueProposalNestedCase,
} as const;
